import React from 'react';
import './styles.scss';

const OutlinedWrapper = ({ customClass, label, children }: any) => (
    <div className={`${customClass ?? ''} outlined-wrapper`}>
        <div className="label">{label}</div>
        {children}
    </div>
);

export default OutlinedWrapper;
